import { Label } from '../../AccountProfile/ProfileStyles';
import styled from 'styled-components/macro';
import React, { useState, useEffect, useRef } from 'react';
import Asterix from '../../../assets/asterix.svg';
//import closeCircle from '../../../assets/close-circle.svg';
import { closeCircle } from '../../../assets/components/svgs';
import useOutsideClick from '../../../hooks/useOutsideClick';
import { useTranslation } from 'react-i18next';
import './pills.css';

interface PillsButtonProps {
  label?: string;
  formData?: any;
  setFormData?: Function;
  rows?: number;
  pillsData: Array<any>;
  removeFilter: Function;
  defaultPillsLabel?: string;
  disabled?: boolean;
  pillMaxWidth?: string;
  pillId?: string;
  onClick?: Function;
}

const PillsButton = ({
  label,
  formData,
  setFormData,
  rows = 2, //Default to 2 rows if not provided
  pillsData,
  removeFilter,
  defaultPillsLabel,
  disabled = false,
  pillMaxWidth = '40%',
  pillId = 'pillContainer',
  onClick = () => {}
}: PillsButtonProps) => {
  const { t } = useTranslation();

  const [showAll, setShowAll] = useState(false);
  const [showMoreLess, setShowMoreLess] = useState(false);

  const toggleEllipsis = () => {
    setShowAll(!showAll);
  };

  const isEllipsisActive = () => {
    const element = document.getElementById(pillId);
    if (!element) return false;
    return element.scrollHeight > element.clientHeight;
  };

  useEffect(() => {
    if (isEllipsisActive() && !showAll) {
      setShowMoreLess(false);
    } else {
      setShowMoreLess(true);
    }
  }, [showAll, pillsData]);

  return (
    <>
      {label && <Label>{t(label)}</Label>}
      <PillsContainer>
        <div className="box-pill">
          <input className="input-pill" type="checkbox" id={`pillButton-${pillId}`} />
          <p id={pillId} className="p-pill" style={{ WebkitLineClamp: showAll ? 'unset' : rows }}>
            {pillsData &&
              pillsData.map((obj, index) => {
                return (
                  <div
                    onClick={(event) => {
                      event.stopPropagation();
                      onClick(index);
                    }}
                    className={`mr-1 mt-1 inline-flex items-center rounded-full bg-[#E4F2FF] px-3 py-[0.1rem] text-[#003A70]`}
                  >
                    {obj.label && <PillsContainerSpanlabel>{obj.label}:</PillsContainerSpanlabel>}
                    {obj.name && (
                      <PillsContentName>
                        <span title={obj.name}>{obj.name}</span>
                      </PillsContentName>
                    )}
                    <PillsContainerAnchor
                      className={disabled ? 'disabled' : ''}
                      onClick={(event: any) => {
                        removeFilter(obj, index, event);
                      }}
                    >
                      {closeCircle}
                    </PillsContainerAnchor>
                  </div>
                );
              })}
          </p>
          {showMoreLess && (
            <div className="label-not-pill" onClick={toggleEllipsis}>
              <label role="button" htmlFor={`pillButton-${pillId}`}>
                Show less
              </label>
            </div>
          )}
          {!showMoreLess && (
            <div className="label-pill" onClick={toggleEllipsis}>
              <label role="button" htmlFor={`pillButton-${pillId}`}>
                Show more
              </label>
            </div>
          )}
        </div>
      </PillsContainer>
    </>
  );
};

const PillsContainer = styled('div')`
  // width: 100%;
  // display: flex;
  // flex-wrap: wrap;
`;

const PillsContent = styled('div')`
  //max-width: 40%;
`;

const PillsContentName = styled('p')`
  max-width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const PillsMultiLine = styled('div')`
  // overflow: hidden;
  // display: -webkit-box;
  // -webkit-box-orient: vertical;
  // -webkit-line-clamp: 3; /* start showing ellipsis when 3rd line is reached */
  // white-space: pre-wrap; /* let the text wrap preserving spaces */
`;

const PillsContainerSpan = styled('span')`
  cursor: auto;
`;
const PillsContainerSpanlabel = styled('span')`
  cursor: auto;
  color: #595959;
  margin-right: 0.25rem;
}
`;

const PillsContainerAnchor = styled('a')`
  cursor: pointer;
  &.disabled {
    pointer-events: none;
  }
`;

const Text = styled.div`
  display: flex;
  flex: 1 1 0;
  justify-content: flex-start;
  flex-flow: row wrap;
`;

export default PillsButton;
